export default __webpack_public_path__ + "puzzle-piece-silhouette.png";